import { useTranslation } from "react-i18next";
import { buildLanguageUrl } from "../utils/buildLanguageUrl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheck,
    faChevronDown
} from "@fortawesome/pro-regular-svg-icons";

const LanguageOptionDropdown = () => {
    const { i18n } = useTranslation();
    

    // @ts-ignore
    const currentLang = window.wpml_language_codes?.current_lang || "en";
    // @ts-ignore
    const languageCodes = window.wpml_language_codes?.language_codes || [];
    // @ts-ignore
    const languageAttributes = window.wpml_language_codes?.language_attributes || {};

    const handleLanguageClick = (languageCode) => {
        const newUrl = buildLanguageUrl(languageCode);

        i18n.changeLanguage(languageCode);
        window.location.href = newUrl;
    }

    const handleToggleClick = () => {
        const menu = document.querySelector(".language-dropdown__menu");
        if (menu) menu.classList.toggle("is-open");

        const handleClickOutside = (event) => {
            const dropdown = document.querySelector(".language-dropdown");
            if (dropdown && !dropdown.contains(event.target)) {
                const menu = document.querySelector(".language-dropdown__menu");
                if (menu) menu.classList.remove("is-open");
                document.removeEventListener("mousedown", handleClickOutside);
            }
        };

        if (menu && menu.classList.contains("is-open")) {
            document.addEventListener("mousedown", handleClickOutside);
        }
    };

    const isActiveLanguage = (languageCode) => {
        return currentLang === languageCode;
    };

    return (
        <div className="language-dropdown">
            <button
                className="language-dropdown__toggle"
                onClick={handleToggleClick}
            >
                <span className="language-dropdown__selected">
                    <img
                        src={languageAttributes[currentLang].flag}
                        alt="Selected Language"
                        className="language-dropdown__selected-flag"
                    />
                    {currentLang.toUpperCase()}
                </span>
                <FontAwesomeIcon
                    className="language-dropdown__arrow"
                    icon={faChevronDown}
                    style={{ color: "#fff" }}
                />
            </button>
            <div className="language-dropdown__menu">
                {languageCodes.map(languageCode => {
                    const langData = languageAttributes[languageCode];
                    if (!langData) return null;

                    return (
                        <button
                            key={languageCode}
                            className={`language-dropdown__item flag-icon-${languageCode} ${isActiveLanguage(languageCode) ? "is-active" : ""}`}
                            onClick={() => handleLanguageClick(languageCode)}
                        >
                            <FontAwesomeIcon
                                className="language-dropdown__item-check"
                                icon={faCheck}
                                style={{ color: "#fff" }}
                            />
                            <img src={langData.flag} alt={langData.name} />
                            <span>{langData.name}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default LanguageOptionDropdown;